<template>
  <v-dialog 
    v-model="navigation.rejectCRMWhatsappConversationDialogIsVisible" 
    @update:model-value="navigation.rejectCRMWhatsappConversationDialogIsVisible == false ? closeRejectCRMWhatsappConversationDialog() : null" 
    max-width="80vw" 
    style="user-select: none; cursor: default;"
  >    
    <v-card style="max-height: 90vh; display: flex; flex-direction: column;">
      <div style="position: sticky; top: 0; z-index: 10; background: white;">
        <v-card color="primary" rounded="0" elevation="0" class="headerCard">
          <div class="titleContainer">
            <v-icon color="indigo" size="large">mdi-chat-processing</v-icon>
            <h3>DEJAR CONVERSACIÓN</h3>
          </div>
          <div class="actionsContainer">
            <template v-if="navigation.CRMWhatsappConversation">
              <template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == navigation.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID)">
                <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == navigation.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" label>
                  <div style="display: flex; align-items: center;">
                    <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == navigation.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == navigation.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                  </div>
                </v-chip>
              </template>
              <template v-else>
                <v-chip color="primary" variant="flat" elevation="2" label>
                  <div style="display: flex; align-items: center;">
                    <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <p>No registrado</p>
                  </div>
                </v-chip>
              </template>
            </template>
            <v-btn 
              @click="closeRejectCRMWhatsappConversationDialog()"
              :disabled="loader.selectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog || loader.rejectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog"
              color="error" 
              class="hoverableText" 
            >
              <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
              <p>CERRAR</p>
            </v-btn>
          </div>
        </v-card>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
      </div>
      <div style="flex: 1; overflow-y: auto;">
        <template v-if="loader.selectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog">
          <div style="padding: 15px; text-align: center;">
            <v-progress-circular color="indigo" indeterminate></v-progress-circular>
          </div>
        </template>
        <template v-else>
          <div class="dataContainer">
            <div style="display: flex; flex-direction: column; gap: 10px;">
              <div style="display: flex; gap: 5px; align-items: center;">
                <v-icon color="indigo">mdi-barcode</v-icon>
                <p><strong>ID: </strong>{{ navigation.CRMWhatsappConversation.CRMWhatsappConversationID }}</p>
              </div>
              <div style="display: flex; gap: 5px; align-items: center;">
                <v-icon color="indigo">mdi-card-account-details</v-icon>
                <p><strong>SSN: </strong>{{ navigation.CRMWhatsappConversation.CRMWhatsappContactSSN || 'No registrado' }}</p>
              </div>
              <div style="display: flex; gap: 5px; align-items: center;">
                <v-icon color="indigo">mdi-account</v-icon>
                <p><strong>Nombre: </strong>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(navigation.CRMWhatsappConversation) }}</p>
              </div>
              <div style="display: flex; gap: 5px; align-items: center;">
                <v-icon color="indigo">mdi-phone</v-icon>
                <p><strong>Teléfono: </strong>{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(navigation.CRMWhatsappConversation.CRMWhatsappContactPhoneNumber) }}</p>
              </div>
            </div>
            <div style="display: flex; flex-direction: column; gap: 10px;">
              <div style="display: flex; gap: 5px; align-items: center;">
                <v-icon color="indigo">mdi-email</v-icon>
                <p><strong>Correo electrónico: </strong>{{ navigation.CRMWhatsappConversation.CRMWhatsappContactEmail || 'No registrado' }}</p>
              </div>
              <div style="display: flex; gap: 5px; align-items: center;">
                <v-icon color="indigo">mdi-store</v-icon>
                <p style="margin-right: 5px;"><strong>Localidad: </strong></p>
                <template v-if="navigation.CRMWhatsappConversation.CRMWhatsappContactCRMLocalityID && systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == navigation.CRMWhatsappConversation.CRMWhatsappContactCRMLocalityID)">
                  <v-chip :color="systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == navigation.CRMWhatsappConversation.CRMWhatsappContactCRMLocalityID).CRMLocalityColor || 'primary'" variant="flat" elevation="2" label>
                    <p>{{ systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == navigation.CRMWhatsappConversation.CRMWhatsappContactCRMLocalityID).CRMLocalityName || 'No registrada' }}</p>
                  </v-chip>
                </template>
                <template v-else>
                  <v-chip color="primary" variant="flat" elevation="2" label>
                    <p>No registrada</p>
                  </v-chip>
                </template>
              </div>
              <div style="display: flex; gap: 5px; align-items: center;">
                <v-icon color="indigo">mdi-calendar-start</v-icon>
                <p><strong>Primera orden: </strong>{{ navigation.CRMWhatsappConversation.firstCRMWhatsappInvoiceCreationDatetime ? $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(navigation.CRMWhatsappConversation.firstCRMWhatsappInvoiceCreationDatetime) : 'No registrada' }}</p>
              </div>
              <div style="display: flex; gap: 5px; align-items: center;">
                <v-icon color="indigo">mdi-calendar-end</v-icon>
                <p><strong>Última orden: </strong>{{ navigation.CRMWhatsappConversation.lastCRMWhatsappInvoiceCreationDatetime ? $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(navigation.CRMWhatsappConversation.lastCRMWhatsappInvoiceCreationDatetime) : 'No registrada' }}</p>
              </div>
            </div>
          </div>
          <v-card color="borderInner" elevation="0" rounded="0" style="width: 100%; height: 1px;"></v-card>
          <div style="padding: 15px;">
            <p>La conversación <strong>{{ navigation.CRMWhatsappConversation.CRMWhatsappConversationID }}</strong> con el contacto <strong>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(navigation.CRMWhatsappConversation) }}</strong> será asignada a la cola de conversaciones pendientes</p>
          </div>
        </template>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
        <v-card color="primary" elevation="0" rounded="0" style="padding: 15px;">
          <v-btn 
            @click="rejectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog()"
            :disabled="loader.selectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog || loader.rejectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog"
            color="indigo" 
            block
            class="hoverableText" 
          >
            <v-icon style="margin-right: 10px;">mdi-chat-processing</v-icon>
            <h3>DEJAR CONVERSACIÓN</h3>
          </v-btn>
        </v-card>
      </div>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
  .headerCard {
    padding: 15px;
    display: grid;
    justify-content: center;
    align-items: center;
    gap: 10px;
    grid-template-columns: repeat(2, 1fr);
  }
  
  .titleContainer {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .actionsContainer {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  .dataContainer {
    padding: 15px;
    gap: 10px;
    display: grid;
    justify-content: center;
    align-items: center;
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 1200px) {
    .headerCard {
      grid-template-columns: repeat(1, 1fr);
    }

    .titleContainer {
      justify-content: center;
    }

    .actionsContainer {
      justify-content: center;
      margin-left: 0;
    }

    .dataContainer {
      grid-template-columns: repeat(1, 1fr);
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    data: () => 
    ({
      navigation: 
      {
        rejectCRMWhatsappConversationDialogIsVisible: false,
        CRMWhatsappConversationID: null,
        CRMWhatsappContactID: null,
        CRMWhatsappConversation: null
      },
      loader: 
      {
        selectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog: false,
        rejectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        CRMAgents: [],
        CRMLocalities: [],
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    methods:
    {

      async selectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog(){
        this.loader.selectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog = true;
        const selectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialogRequestQuery = 
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversationID,
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID
        };
        const selectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/functions/selectCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog', selectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialogRequestQuery);
        if (selectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialogResult.success){
          this.navigation.CRMWhatsappConversation = selectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialogResult.result;
          this.loader.selectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog_error', 'error', 'Ha ocurrido un error inesperado al obtener la conversación, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.closeRejectCRMWhatsappConversationDialog();
        }
      },

      async rejectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog(){
        this.loader.rejectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog = true;
        const rejectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialogRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversation.CRMWhatsappConversationID
        };
        const rejectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/functions/rejectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog', rejectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialogRequestQuery);
        if (rejectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialogResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('rejectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog_success', 'success', `La conversación con el contacto ${this.$displayFunctions.default.parseCRMWhatsappContactNameToDisplay(this.navigation.CRMWhatsappConversation)} ha sido asignada a la cola de conversaciones pendientes`, null, true);
          this.closeRejectCRMWhatsappConversationDialog();
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('rejectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog_error', 'error', `Ha ocurrido un error inesperado al asignar la conversación con el contacto ${this.$displayFunctions.default.parseCRMWhatsappContactNameToDisplay(this.navigation.CRMWhatsappConversation)} a la cola de conversaciones pendientes, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
        }
        this.loader.rejectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog = false;
      },

      async getSystemInformationData(){
        this.loader.selectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog = true;
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            if (!this.systemInformationData.updateSubscription){
              this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
                this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
              });
            }          
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
            this.closeRejectCRMWhatsappConversationDialog();
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          this.closeRejectCRMWhatsappConversationDialog();
        }
      },

      async openRejectCRMWhatsappConversationDialog(CRMWhatsappConversationID, CRMWhatsappContactID){
        await this.getSystemInformationData();
        this.navigation.CRMWhatsappConversationID = CRMWhatsappConversationID;
        this.navigation.CRMWhatsappContactID = CRMWhatsappContactID;
        this.navigation.CRMWhatsappConversation = null;
        this.loader.rejectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog = false;
        this.navigation.rejectCRMWhatsappConversationDialogIsVisible = true;
        await this.selectCRMWhatsappConversationFromRejectCRMWhatsappConversationDialog();
      },

      closeRejectCRMWhatsappConversationDialog(){
        this.navigation.rejectCRMWhatsappConversationDialogIsVisible = false;
        this.$emit('closeCRMWhatsappConversationDialog');
      }
    }
  }
</script>